export const DEV_TOOL = {
  SEARCH_PARAM: {
    LOGIN_COUNTRY: "login-country",
  },
  SESSION_STORAGE: {
    LOGIN_COUNTRY: "devtool-login-country",
  },
};
